import React from 'react';
import { IProps, IState } from './types';
import service from 'bff/services/carProductService';
import _ from 'lodash';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import InsTypeDefines from 'constants/models/insTypeDefines';
import { InsType } from 'constants/enums/insType.enum';
import { SysOption } from 'bff/models/info';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
// import { withRouter } from 'react-router-dom';
import { PayerContent } from 'bff/models/member/boPayby';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';
import { GamePOI } from 'constants/enums/gamePOI.enum';
import gameService from 'bff/services/gameService';

class InsureProcessSuccess extends React.Component<IProps, IState> {
  state: IState = {
    insDoneCode: new Array(0),
    insDoneBarCode: new Array(0),
    emailNotifySysOpts: new Array(0),
    docIdSysOpts: new Array(0),
    applyType: '',
    policyDeliverySysOpts: new Array(0),
    barCodeUrl: ''
  }

  componentDidMount = async () => {
    commonService.scrollToTop();
    const tempState = this.props.tempState;

    let applyType = '';
    if (tempState.boPayby.BC_TYPE) {
      applyType = tempState.boPayby.BC_TYPE;
    }

    if (tempState.addReq) {
      applyType = tempState.addReq.PET_POLICY.BC_TYPE;
    }

    const initSetting = await service.fetchInitSuccess();

    // 若是以帳戶轉帳或信用卡支付且有要保號，走到此頁視為「已繳款」，則查詢抽獎資格
    if (
      tempState.addReq &&
      tempState.addReq.PET_POLICY.APPLY_NO
    ) {
      const _applyNo = tempState.addReq.PET_POLICY.APPLY_NO;
      const args = {
        GAMEPOI: GamePOI.INSURE,
        APPLY_NO: _applyNo
      };
      const response = await gameService.gameChkqualify(args);
      if (response && response.QUALIFIED_DCNT > 0) {
        // 顯示抽獎資格提示跳窗
        this.props.setGameQualifyModalVisible(true, GamePOI.INSURE, _applyNo, response);
      }
    }

    this.setState({
      applyType: applyType,
      insDoneCode: [...initSetting.insDoneCode],
      insDoneBarCode: [...initSetting.insDoneBarCode],
      emailNotifySysOpts: [...initSetting.emailNotifySysOpts],
      docIdSysOpts: [...initSetting.docIdSysOpts],
      policyDeliverySysOpts: [...initSetting.policyDeliverySysOpts]
    });
  }

  /**
   * @description 取得投保完成訊息1
   */
  handleSuccessMsg1st = () => {
    let applicantName;
    if (this.props.tempState.boPayby.APPLY_NO) {
      const insureds =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      applicantName = insureds[0].NAME;
    }

    if (this.props.tempState.addReq && this.props.tempState.addReq.PET_POLICY) {
      applicantName = this.props.tempState.addReq.PET_POLICY.APPLICANT_NAME;
    }

    // fake
    applicantName = this.props.tempState.addReq.PET_POLICY.APPLICANT_NAME;

    if (!applicantName) return;

    let msg = '';
    if (!msg) {
      msg = this.handleFormatMsg(CodeId.PET01, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[this.props.insTypeId as InsType]);
    }

    return (
      <p>
        {`親愛的${applicantName}您好：`}<br />
        <span>{commonService.htmlParser(msg)}</span>
      </p>
    );
  }

  /**
   * @description 取得投保完成訊息3
   */
  handleSuccessMsg4th = () => {
    const msg = this.handleGetSysMsg(this.state.emailNotifySysOpts, SysOptParamId.EMAIL_NOTIFY_CUSTOM_SERVICE);
    if (!msg) return null;

    let msgInfo: any = msg;

    if (msg.indexOf('：') !== -1) {
      const msgArray = msg.split('：');

      msgInfo = _.map(msgArray, (msg: string, index: number) => {
        return React.cloneElement(
          <>
            {msg} <br />
          </>
          , { key: index });
      });
    }

    return <p>{msgInfo}</p>;
  }

  /**
   * @description 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.state.insDoneCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
   * @description 取得顯示文字
   */
  handleGetMsgInfo = (msg: string, ...params: any) => {
    if (params && params.length > 0) {
      for (let i = 0; i < params.length; i += 1) {
        msg = msg.replace(`{#PARAM${i + 1}}`, params[i]);
      }
    }

    return msg;
  }

  /**
    *@description 取得系統參數值
    */
  handleGetSysMsg = (sysOpts: SysOption[], paramId: string) => {
    return _.find(sysOpts, (sysOpt: SysOption) => sysOpt.PARAM_ID === paramId)?.PARAM_VALUE;
  }

  /**
   * @description 取得保單寄送方式文字
  */
  handleGetDeliveryText = (type: string) => {
    return _.find(this.state.policyDeliverySysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === type)?.PARAM_TEXT;
  }

  /**
   * @description 取得保單寄送方式參數值
  */
  handleGetDeliveryType = (delivery: string) => {
    return delivery === PolicyDelivery.Electric
      ? SysOptParamId.EMAIL_NOTIFY_PODELIVER_EPAPER
      : SysOptParamId.EMAIL_NOTIFY_PODELIVER_PAPER;
  }

  /**
   * @description 判斷是否包含判斷型態的投保項目
   */
  handleValidateHasType = (insuredPolicys: any, targetType: string) => {
    return _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === targetType) !== -1;
  }

  render () {
    /**
      * @description 依投保項目產生對應的投保日期顯示區塊
     */
    const handleGetInsuredDateInfo = () => {
      const resArray = new Array(0);
      let insDate;
      if (this.props.tempState.boPayby.APPLY_NO) {
        insDate = moment(this.props.tempState.boPayby.CO_START_DATE).isValid()
          ? this.props.tempState.boPayby.CO_START_DATE
          : '';
      }
      if (this.props.tempState.addReq.PET_POLICY) {
        insDate = this.props.tempState.addReq.PET_POLICY.START_DATE;
      }

      if (insDate) {
        resArray.push(
          <p key={0}>
            {
              // `寵物險預定生效日：${insDate.format('YYYY年MM月DD日')}凌晨0時起，保期一年`
              `寵物險預定生效日：${moment(insDate).format('YYYY年MM月DD日')}凌晨0時起，保期一年`
            }
          </p>
        );
      }

      return resArray;
    };

    /**
     * @description 建立保障區塊
     */
    const handleGetInsuredContent = () => {
      let serialNo;
      let insuredName;
      let fee;
      let delivery = '';
      if (this.props.tempState.boPayby.APPLY_NO) {
        serialNo = this.props.tempState.boPayby.APPLY_NO;
        const insureds =
          _.filter(this.props.tempState.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        insuredName = insureds[0].NAME;
        fee = this.props.tempState.boPayby.POLICY_FEE;
        delivery = this.props.tempState.boPayby.POLICY_DELIVERY;
      }

      // if (this.props.tempState) {
      //   serialNo = this.props.tempState.addReq.PET_POLICY.APPLY_NO;
      //   insuredName = this.props.tempState.addReq.PET_POLICY.INSURED_NAME;
      //   fee = this.props.tempState.addReq.PET_POLICY.TOTAL_FEE;
      //   delivery = this.props.tempState.addReq.PET_POLICY.POLICY_DELIVERY;
      // }

      if (this.props.tempState) {
        serialNo = this.props.tempState.addReq.PET_POLICY.APPLY_NO;
        insuredName = this.props.tempState.addReq.PET_POLICY.INSURED_NAME;
        fee = this.props.tempState.addReq.PET_POLICY.TOTAL_FEE;
        delivery = this.props.tempState.addReq.PET_POLICY.POLICY_DELIVERY;
      }

      if (!serialNo || !insuredName || !delivery) return;

      return (
        <>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">網路投保交易序號</div>
              <div className="element__list-group-content">{serialNo}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">被保險人姓名</div>
              <div className="element__list-group-content">{insuredName}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">交易金額</div>
              <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(`${fee}`)}`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保單寄送方式</div>
              <div className="element__list-group-content">
                {
                  `${this.handleGetDeliveryText(delivery)}:${this.handleGetSysMsg(this.state.emailNotifySysOpts, this.handleGetDeliveryType(delivery))}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保險期間</div>
              <div className="element__list-group-content">
                {
                  handleGetInsuredDateInfo()
                }
              </div>
            </div>
          </div>
        </>
      );
    };

    return (
      <div className="insure-process-success insure-process-success--pet">
        {/* 投保完成 */}
        <div className="insured-complete">
          <div className="insured-complete__title">投保完成</div>
          <div className="insured-complete__content">
            <div className="insure-process-success__part">
              {this.handleSuccessMsg1st()}
            </div>
          </div>
        </div>
        {/* 保險內容 */}
        <div className="insurance-content">
          <div className="insurance-content__title">保險內容</div>
          <div className="insurance-content__content">
            <div className="element__list">
              {
                handleGetInsuredContent()
              }
              <div className="element__list-col">
                <div className="insure-process-success__part">
                  {this.handleSuccessMsg4th()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGameQualifyModalVisible:
    (visible: boolean, gamePoi: string, applyNo: string, checkResult: GameChkqualifyResp) =>
      dispatch(setGameQualifyModalVisibleAction(visible, gamePoi, applyNo, checkResult))
});

export default connect(null, mapDispatchToProps)(InsureProcessSuccess);
